/**
 * Inflow brand wordmark.
 * Brand glyph (SVG path) + текст "inflow." з помаранчевою крапкою.
 *
 * Glyph — кастомний фірмовий знак (Downloads/path14.svg), фарбується
 * у `accent` (помаранчевий бренд-колір).
 */
import { Link } from "react-router-dom";

interface InflowLogoProps {
  size?: number;
  ink?: string;
  accent?: string;
  /** Якщо задано — лого стає клікабельним і веде за цим маршрутом
   *  (юзер 2026-06-25: «тап по лого завжди веде в головне меню»).
   *  Передаємо to="/" у хедерах; в онбордингу/інструкції НЕ передаємо. */
  to?: string;
}

export function InflowLogo({
  size = 18,
  ink = "#171411",
  accent = "#FE6B04",
  to,
}: InflowLogoProps) {
  const inner = (
    <>
      <svg
        width={size * 1.1}
        height={size * 1.1}
        viewBox="0 0 7 7"
        fill="none"
      >
        <path
          d="M3.86571 0.00100987C4.70872 0.00100987 5.47668 0.344409 6.03334 0.900108C6.59101 1.4548 6.93546 2.22376 6.93546 3.07081C6.93546 3.91382 6.59202 4.68177 6.03636 5.23848C5.47668 5.79716 4.70872 6.14056 3.86571 6.14056C3.01866 6.14056 2.24975 5.79615 1.69505 5.24146C1.1394 4.68178 0.795955 3.91382 0.795955 3.07081L1.58993 2.27481L2.38589 3.07081C2.38589 3.48028 2.55113 3.85274 2.81745 4.11906C3.08474 4.38443 3.45623 4.55063 3.86571 4.55063C4.27519 4.55063 4.64764 4.38543 4.91397 4.11906C5.18029 3.85274 5.34553 3.48028 5.34553 3.07081C5.34553 2.66128 5.17933 2.28984 4.913 2.02351C4.64764 1.75618 4.27519 1.59099 3.86571 1.59099C2.58714 1.59099 1.27856 1.59195 0 1.59195L0.795955 0.795998L0 0C1.27856 0 2.58714 0.00100987 3.86571 0.00100987Z"
          fill={accent}
        />
      </svg>
      <span>
        inflow<span style={{ color: accent }}>.</span>
      </span>
    </>
  );

  const cls = "inline-flex items-center font-display font-bold tracking-tight";
  const style = { fontSize: size, color: ink, gap: size * 0.28 };

  if (to) {
    return (
      <Link to={to} className={cls + " active:scale-95 transition"} style={style}>
        {inner}
      </Link>
    );
  }
  return (
    <span className={cls} style={style}>
      {inner}
    </span>
  );
}
